import React, { useEffect, useState, useRef } from 'react'
import { AdView, buildDecision } from '@paypalcorp/consumerweb-ads'
import logger from 'lib/logger'
import { KevelAd } from 'types/graphql/fragments/KevelAd'

interface AdSlotProps {
  className?: string
  kevelAds?: KevelAd[]
}

// Define ad options for the updated library (v1.0.6+)
const adOptions = {
  divName: 'ad-container',
  log: (error: any) => {
    logger.error('AdSlot error:', error)
  },
  pageName: 'shopping_page'
}

const AdSlot = ({ className = '', kevelAds }: AdSlotProps) => {
  const [adDecision, setAdDecision] = useState<any | null>(null)
  const isMountedRef = useRef(true)

  // Cleanup on unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  // Convert GraphQL response to AdDecision using consumerweb-ads utility
  useEffect(() => {
    if (kevelAds && kevelAds.length > 0 && isMountedRef.current) {
      try {
        const decision = buildDecision({ data: { uiShopping: { kevelAds } } })
        if (decision && isMountedRef.current) {
          setAdDecision(decision)
        }
      } catch (error) {
        logger.error('Error building ad decision:', error)
      }
    } else {
      // Clear ad decision when no ads
      setAdDecision(null)
    }
  }, [kevelAds])

  // Only show ads when we have ads data
  if (!kevelAds?.length) {
    return null
  }

  // Only show ads when we have a valid ad decision, otherwise return null
  if (!adDecision) {
    return null
  }

  return (
    <div className={className} data-cy="ad_slot">
      <AdView adOptions={adOptions} adDecision={adDecision} />
    </div>
  )
}

export default AdSlot
